import React from 'react';
import { useNavigate } from 'react-router-dom';

const WarningPopup = ({ isOpen, message, onClose, formData }) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    const handleManualRequest = () => {
        // Transform the data structure
        const transformedData = {
            loadCountry: formData.originCountry,
            unloadCountry: formData.destinationCountry,
            loadCity: formData.originCity,
            unloadCity: formData.destinationCity,
            items: formData.items.map(item => ({
                itemName: item.itemName,
                itemHSCode: item.itemHSCode,
                itemValue: item.itemValue,
                countryOrigin: item.countryOrigin,
                quantity: item.quantity,
                hasHSCode: item.hasHSCode
            })),
            pcsPackage: formData.dimensions.map(dim => ({
                quantity: dim.quantity.value,
                weight: dim.weight,
                length: dim.length,
                width: dim.width,
                height: dim.height
            }))
        };

        // Store the transformed data in sessionStorage
        sessionStorage.setItem('estimateFormData', JSON.stringify(transformedData));

        // Navigate to the new quote request page
        navigate('/new-quote-request');
        onClose();
    };

    const renderMessage = (message) => {
        const emailRegex = /(operations@oneunionsolutions\.com)/;
        const parts = message.split(emailRegex);

        return parts.map((part, index) => {
            if (emailRegex.test(part)) {
                return (
                    <a
                        key={index}
                        href={`mailto:${part}`}
                        className="text-blue-600 hover:text-blue-800 underline"
                    >
                        {part}
                    </a>
                );
            }
            return part;
        });
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
                <div className="flex flex-col gap-4 items-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-10 w-10 text-yellow-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                    </svg>
                    <p className="text-gray-600 text-center">{renderMessage(message)}</p>
                    <div className="flex gap-4 justify-end mt-4">
                        <button
                            onClick={handleManualRequest}
                            className="px-4 py-2 bg-orange-600 text-white rounded hover:bg-blue-700 transition-colors"
                        >
                            Send request manually
                        </button>
                        <button
                            onClick={onClose}
                            className="px-4 py-2 bg-yellow-600 text-white rounded hover:bg-yellow-700 transition-colors"
                        >
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WarningPopup;